<template>
  <div id="informacje">
    <T1HeadScripts rodzajstrony="onas" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1Breadcrumbs
            class="mb-24"
            :homeLink="true"
            :items="getBreadcrumbs()"
          />
        </a-layout-content>
        <h2 class="font-24 font-r">{{ getPageTitle() }}</h2>
        <a-row :gutter="16">
          <a-col :lg="16" :xl="17">
            <div class="content-pane content-pane_white mb-48">
              <router-view />
            </div>
          </a-col>
          <a-col :lg="8" :xl="7">
            <T1AsideTabNav :links="links" />
            <T1AsideAwards />
          </a-col>
        </a-row>
        <div class="layout-segment">
          <div class="layout-segment__header">
            <h3 class="layout-segment__title">
              Podróże z Grupą TravelOne.pl: wczasy i wycieczki
            </h3>
          </div>
          <T1GroupLinks />
        </div>
      </div>
      <!-- <T1Newsletter /> -->
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1Breadcrumbs from "./components/T1Breadcrumbs/T1Breadcrumbs";
import T1AsideTabNav from "./components/T1AsideTabNav";
import T1AsideAwards from "./components/T1AsideAwards";
import T1GroupLinks from "./components/T1GroupLinks";
// import T1Newsletter from "./components/T1Newsletter";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "informacje",
  data: () => ({
    links: [
      { path: "onas.html", title: "O nas" },
      { path: "kontakt.html", title: "Kontakt" },
      { path: "regulamin.html", title: "Regulamin" },
      { path: "polityka-prywatnosci.html", title: "Polityka prywatności" }
    ]
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: this.$route.name, link: "" });
      return crumbsArr;
    },
    getPageTitle() {
      return this.$route.name;
    }
  },
  components: {
    T1HeadScripts,
    T1Header,
    T1Breadcrumbs,
    T1AsideTabNav,
    T1AsideAwards,
    T1GroupLinks,
    // T1Newsletter,
    T1Footer
  }
};
</script>
